import React, { useState } from "react";
import "./Footer.scss";
import DTCH  from "../../assets/svg/dtch.svg";
import QR  from "../../assets/svg/dtch-qr.svg";
import Deloitte from "../../assets/svg/deloitte.svg";
interface IProps {
    onTouchExport: () => void;
}

export function Footer(props: IProps) {
    const isRunningForDeloitte = window.location.href.split('emission.dtch.nl').length > 1;
    const [qrVisible, setQrVisible] = useState<boolean>(false);


    return (
        <>
            <div className="footer-wrapper">
                <div className="left-side">
                    <div className="left-side-contents">
                        <div>
                            Powered by<br />
                            <b>VisualCenter Deloitte<span className={'green'}>.</span></b>
                        </div>
                        {isRunningForDeloitte ? undefined : <>
                            <br />
                            <div>
                                Content Creation by<br />
                                <b>Digital Touch Productions</b>
                            </div>
                        </>}
                    </div>
                </div>
                <div className="right-side">
                    {isRunningForDeloitte ? <img src={Deloitte} alt="Deloitte" onClick={() => setQrVisible(!qrVisible)} /> : <img src={DTCH} alt="Deloitte" onClick={() => setQrVisible(!qrVisible)} />}
                    {/*<img src={Deloitte} alt="Deloitte" onClick={props.onTouchExport} />*/}
                    {/*<img src={DTCH} alt="Deloitte" onClick={() => setQrVisible(!qrVisible)} />*/}
                </div>
            </div>
            <div className={`qr-wrapper ${qrVisible ? 'visible' : ''}`} onClick={() => setQrVisible(false)}>
                <img src={QR} alt="dtch"/>
                <h5>Scan to see this experience live</h5>
                <span>
                    Custom made content by <b>digitaltouch.nl</b>.
                </span>
            </div>
        </>
    )
}
